// extracted by css-extract-rspack-plugin
export default {"singlePane":"singlePane-bxpUwU","splitPane":"splitPane-pVkTTC","pane":"pane-sN1LOG","leftPane":"leftPane-bgh68u","rightPane":"rightPane-BvO_PB","extraPane":"extraPane-xu_Ei1"};